"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PrimitivePropertyCondition_1 = require("./PrimitivePropertyCondition");
var NumberType;
(function (NumberType) {
    NumberType[NumberType["arbitrary"] = 0] = "arbitrary";
    NumberType[NumberType["integer"] = 1] = "integer";
    NumberType[NumberType["float"] = 2] = "float";
})(NumberType || (NumberType = {}));
class NumberCondition extends PrimitivePropertyCondition_1.PrimitivePropertyCondition {
    constructor(property) {
        super(property, "number");
        this.numberType = NumberType.arbitrary;
    }
    integer() {
        this.numberType = NumberType.integer;
        return this;
    }
    float() {
        this.numberType = NumberType.float;
        return this;
    }
    isFulfilled(value) {
        const superResult = super.isFulfilled(value);
        if (!superResult.fulfilled) {
            return superResult;
        }
        if (this.passesNullOrUndefined(value)) {
            return { fulfilled: true };
        }
        if (this.numberType === NumberType.integer && !Number.isInteger(value[this.property])) {
            return this.createUnfulfilledResult(value, "is not an integer");
        }
        else if (this.numberType === NumberType.float && Number.isInteger(value[this.property])) {
            return this.createUnfulfilledResult(value, "is not a float");
        }
        return { fulfilled: true };
    }
}
exports.NumberCondition = NumberCondition;
//# sourceMappingURL=NumberCondition.js.map